module.exports = __webpack_public_path__ + "img/ml.204b0da4.svg";